import { guideChangeSelectedIndexThunkAction } from './changeSelectedIndex';
import { guideChangeCurrentPlayingIndexAction } from './changeCurrentPlayingIndex';
import { guidePropertiesSelector } from '../selectors/properties';
import { isChannel } from '../helpers/isChannel';

export const synchPlayerIndexThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  const { content } = state.player;
  const { list } = guidePropertiesSelector(state);
  const currentPlayingIndex = list.findIndex((row) => isChannel(row) && row.id === content.id);
  await dispatch(guideChangeCurrentPlayingIndexAction({ newIndex: currentPlayingIndex }));
  await dispatch(guideChangeSelectedIndexThunkAction({ newIndex: currentPlayingIndex }));
};
